import React from 'react';
import { withTheme } from 'styled-components';

// Zocdoc dependencies
import LazyLoad from '@zocdoc-frontend-common/components-lazy-load';

// This package
import { getSizeFromTheme } from './DoctorImage';

/* Some pages where we render the doctor photo (primarily search) lazy load
 * it using JavaScript to ensure that it lazy loads on all browsers.
 * Other pages where we render the doctor photo (primarily listing) lazy load it
 * using the native lazy load attribute which only works on some browsers (such as
 * modern Chrome versions); they do this because they want to ship microbundles that
 * do not rehydrate React components for an even bigger performance gain than we get
 * from just lazy loading images that appear below the fold. This shared doctor
 * card component supports both.
 */
const MaybeLazyLoad = ({ children, useNativeLazyLoad = true, theme }) => {
    if (useNativeLazyLoad || global.screenshot) {
        return <>{children}</>;
    }

    /* To ensure the size of the Lazyload placeholder is consistent with the size of the
     * actual doctor image that will get lazy loaded, we pull the size from the
     * theme just like the doctor image does.
     */
    const size = getSizeFromTheme(theme);

    return (
        <LazyLoad data-test="doctor-photo-lazy-load" height={size} width={size}>
            {children}
        </LazyLoad>
    );
};

const ThemedMaybeLazyLoad = withTheme(MaybeLazyLoad);

export { MaybeLazyLoad, ThemedMaybeLazyLoad, ThemedMaybeLazyLoad as default };
